import { React } from "../deps/remix.ts";

export const Tooltip = (
  { remaining, description, children }: {
    remaining?: boolean;
    description?: string | null;
    children: React.ReactNode;
  },
) => {
  return (
    <div className="CheckoutPreview__Info">
      <i className="fa-solid fa-circle-info"></i>

      <div className="CheckoutPreview__InfoTooltip">
        {children}
        {description && <p>{description}</p>}
      </div>
    </div>
  );
};
